/**
 * The signer opens `https://<worker-host>/s/:token`. The Worker serves this
 * SPA's index.html for any `/s/...` path, so we read the token from the URL.
 * Returns the last non-empty path segment after `/s/`, or '' if absent.
 */
export function parseTokenFromLocation(pathname: string = window.location.pathname): string {
  const segments = pathname.split('/').filter(Boolean);
  const sIndex = segments.indexOf('s');
  if (sIndex >= 0 && sIndex < segments.length - 1) {
    return decodeURIComponent(segments[segments.length - 1]);
  }
  // Fallback: if not under /s/, treat the last segment as the token.
  if (segments.length > 0) {
    const last = segments[segments.length - 1];
    if (last !== 's') return decodeURIComponent(last);
  }
  return '';
}
